module.exports = __webpack_public_path__ + "img/img18.8baf123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img18.png
// module id = 225
// module chunks = 0